import React from 'react';
import { Grid } from '@material-ui/core';
import { Colors } from 'library';
import EarlyBird from 'assets/icons/provider-profile/early-bird-icon.svg';
import NightOwl from 'assets/icons/provider-profile/night-owl-icon.svg';
import Fish from 'assets/icons/provider-profile/fish-icon.svg';
import WhenDoYouWorkCaption, { WhenDoYouWorkIconType } from './WhenDoYouWorkCaption';
import { Availability } from './CalendarAvailability';
import { getAvailabilityCategory, AvailabilityCategories } from './AvailabilityCategory';

const WORK_TIMES: WhenDoYouWorkIconType[] = [
    {
        icon: <EarlyBird />,
        headerText: 'Early Bird',
        subText: 'Daytime & Weekdays.',
        availabilityCategory: AvailabilityCategories.EarlyBird,
    },
    {
        icon: <NightOwl />,
        headerText: 'Night Owl',
        subText: 'Evenings & Weekends.',
        availabilityCategory: AvailabilityCategories.NightOwl,
    },
    {
        icon: <Fish />,
        headerText: 'Anytime',
        subText: 'Flexible.',
        availabilityCategory: AvailabilityCategories.Flexible,
    },
];

export default function WhenDoYouWork({ availability }: { availability: Availability[] }) {
    const availabilityCategory = getAvailabilityCategory(availability);

    return (
        <Grid container direction="row" spacing={2} style={{ marginTop: 25, maxWidth: 320 }}>
            {WORK_TIMES.map((item) => (
                <Grid item xs={4}>
                    {React.cloneElement(item.icon, {
                        color:
                            availabilityCategory === item.availabilityCategory ? Colors.turquoise : Colors.mediumGrey,
                    })}
                </Grid>
            ))}
            {WORK_TIMES.map((item) => (
                <Grid item xs={4}>
                    <WhenDoYouWorkCaption
                        item={item}
                        color={
                            availabilityCategory === item.availabilityCategory ? Colors.turquoise : Colors.mediumGrey
                        }
                    />
                </Grid>
            ))}
        </Grid>
    );
}
